import { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { errMsg } from "@/lib/api";
import { ROLE_IT } from "@/components/crm/helpers";
import { useTenantPage } from "./useTenantPage";

export function AreaPicker({ isAdmin }) {
  const [q, setQ] = useState("");
  const [arch, setArch] = useState(false);
  const p = useTenantPage({ q: q.trim(), includeArchived: arch });
  const first = !q.trim() && !arch;
  if (!p.loading && !p.error && first && p.total === 1) return <Navigate to={`/area/${p.items[0].id}`} replace />;
  if (!p.loading && !p.error && first && p.total === 0) return (
    <div className="mx-auto max-w-lg rounded-xl border border-slate-200 bg-white p-8 text-center" data-testid="area-no-tenants">
      <p className="text-base font-semibold text-slate-900">Nessuno spazio disponibile</p>
      <p className="mt-2 text-sm text-slate-500">Il tuo account non è ancora membro di nessun cliente. Chiedi al titolare un link d'invito.</p>
    </div>);
  return (
    <div className="mx-auto max-w-3xl space-y-3" data-testid="area-tenant-list">
      <h1 className="text-2xl font-bold text-slate-900 sm:text-3xl">Scegli lo spazio</h1>
      <div className="flex flex-wrap items-center gap-3">
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca cliente…" className="h-11 bg-white sm:h-9 sm:w-80" data-testid="area-tenant-search" />
        {isAdmin && <label className="flex min-h-[44px] cursor-pointer items-center gap-2 text-xs text-slate-600"><input type="checkbox" className="h-5 w-5 accent-sky-600" checked={arch} onChange={(e) => setArch(e.target.checked)} data-testid="area-show-archived" />Mostra archiviati</label>}
        <span className="text-xs text-slate-500" data-testid="area-tenant-count">{p.loading && !p.items.length ? "Caricamento…" : `${p.items.length} di ${p.total}`}</span>
      </div>
      {p.error && <p className="text-sm text-red-700" role="alert" data-testid="area-tenant-error">{errMsg(p.error)}</p>}
      {!p.loading && !p.error && !p.items.length && <p className="text-sm text-slate-500" data-testid="area-tenant-empty">Nessuno spazio trovato.</p>}
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">{p.items.map((t) => (
        <Link key={t.id} to={`/area/${t.id}`} className="block min-w-0 rounded-xl border border-slate-200 bg-white p-4 transition-colors hover:border-sky-300" data-testid={`area-tenant-${t.id}`}>
          <p className="truncate text-sm font-semibold text-slate-900" title={t.name}>{t.name}</p>
          <p className="text-xs text-slate-500">{ROLE_IT[t.role] || "Assistenza MUSORA"}{t.status === "archived" ? " · archiviato" : ""}</p></Link>))}</div>
      {p.has_more && <Button variant="outline" className="h-11 w-full" onClick={p.more} disabled={p.loading} data-testid="area-tenant-more">
        {p.loading ? <Loader2 size={14} className="animate-spin" /> : `Mostra altri (${p.total - p.items.length})`}</Button>}
    </div>
  );
}
